export default "<csi-info-popover\r\n  *ngIf=\"isVisible\"\r\n  class=\"compact\"\r\n  [content]=\"hintKey | transloco\"\r\n></csi-info-popover>\r\n"